/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesLocationCounties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Location County Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 10:08:57 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const LocationCountyList = Loadable({
    loader: () => import('../containers/LocationCounties/LocationCountyListContainer'),
    loading: Loading,
});

export const LocationCountyForm = Loadable({
    loader: () => import('../containers/LocationCounties/LocationCountyEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesLocationCounties.js